module.exports = __webpack_public_path__ + "static/Figma_Balloon-72df9ed9a36a7314f3daef45904dbbf6.png";